import Director from './containers/Director';

export default Director;
